import React, { useState, useEffect, useContext } from "react";
import DocumentFormatTable from "./documentFormatTable";
import CustomLoader from "../../common/commonComponents/Loader/loader";
import { documentServiceBaseUrl, getAPI } from "services/http";
import {
  GetPagination,
} from "../../common/commonComponents/pagination/pagination";
import { PermissionContext, RolePermissions } from "appContext";
import { PermisionDenied } from "../../common/commonComponents";
import { pages } from "../../common/constant";
import { failureToast, successToast} from '../../common/utils/methods/toasterFunctions/function'


const DocumentFormat = (props) => {

  const permissions = useContext(PermissionContext);
  const userPermissions = RolePermissions(permissions, pages["documentFormat"]['id']);

  const [classArray, setclassArray] = useState([]);
  const [apiloader, setapiloader] = useState(false);
  const [state, setstate] = useState([]);
  const [serverData, setServerData] = useState([])
  const [isSaveVisible, setisSaveVisible] = useState(false);
  const [pagination, setpagination] = useState({
    currentPage: 1,
    nextPage: null,
    previousPage: null,
    totalPage: null,
  });
  const pageSize = 10;
  const fetchClasses = async (url) => {
    setapiloader(true);
    getAPI(
      url,
      (data) => {
        setstate(data["data"]);
        setServerData(data['data'])
        setPagination(data["data"])
      },
      (data) => {
        failureToast(data["message"]);
        setapiloader(false);
      }
    );
  };

  const resetSearch = () => {
    setstate(serverData);
    setPagination(serverData)
  }

  const setSearch = (data) => {
    setstate(data);
    setPagination(data)
  }

  const setPagination = (paramsdata) => {
    let n = pagination;
    if (paramsdata.length > pageSize) {
      n["nextPage"] = n.currentPage + 1;
    }
    if (n.currentPage > 1) {
      n.previousPage = n.currentPage - 1;
    }
    n["totalPage"] = Math.floor(paramsdata.length / pageSize);
    if (paramsdata.length % pageSize != 0) {
      n["totalPage"] += 1;
    }
    setpagination(n);
    setclassArray(
      paramsdata.slice(
        pagination.currentPage * pageSize - pageSize,
        pagination.currentPage * pageSize
      ) || []
    );
    setapiloader(false);
  }

  useEffect(() => {
    fetchClasses(`${documentServiceBaseUrl}/documentFormat/getAllDocumentFormats`)
  }, [])


  return (
    userPermissions ?
      <>
        {apiloader ? (
          <div
            className="mx-auto text-center py-5 my-5"
            style={{ height: "100vh" }}
          >
            <CustomLoader apiLoader={apiloader} />
          </div>
        ) : (
          <>
            <DocumentFormatTable
              // previousPage={previousPage}
              fetchClasses={fetchClasses}
              setclassArray={setclassArray}
              classArray={classArray}
              isSaveVisible={isSaveVisible}
              setisSaveVisible={setisSaveVisible}
              resetSearch={resetSearch}
              setSearch={setSearch}
              serverData={serverData}
              userPermissions={userPermissions}
            />
            {pagination.totalPage > 1 ? (
              <GetPagination
                isSaveVisible={isSaveVisible}
                fetchClasses={fetchClasses}
                setclassArray={setclassArray}
                pagination={pagination}
                setpagination={setpagination}
                pageSize={pageSize}
                state={state}
              />
            ) : null}
          </>
        )}
      </> : <PermisionDenied />
  );
};

export default DocumentFormat;
